import {JsonProperty} from "@hyperloris/tyson";


export class Notification {

  @JsonProperty()
  id?: number;

  @JsonProperty()
  type: Notification.TYPE;

  @JsonProperty()
  state: Notification.STATE;

  @JsonProperty()
  content: string;

  @JsonProperty()
  username?: string;

  @JsonProperty()
  taskId: string;

  @JsonProperty()
  dateCreation?: Date;

  @JsonProperty()
  icon?: string;

  @JsonProperty()
  usernames?: string[];

  @JsonProperty()
  ids?: number[];
}

export module Notification {
  export enum TYPE {
    REPORT = 'REPORT',
    RECAP = 'RECAP',
    DOWNLOAD = 'DOWNLOAD',
    PREVIEW = 'PREVIEW',
    CUSTOMER = 'CUSTOMER',
    RELEASE = 'RELEASE',
    ALERT = 'ALERT',
  }

  export enum STATE {
    TREATED = "TREATED",
    ERROR = "ERROR",
  }
}




